let itemsForVirtualCurrencyEnabled = false;

export const setItemsForVirtualCurrencyEnabled = (value: boolean) => {
  itemsForVirtualCurrencyEnabled = value;
};

export const isItemsForVirtualCurrencyEnabled = () =>
  itemsForVirtualCurrencyEnabled;
